import React from 'react';
import {
    SimpleForm,
    TextInput,
    DateInput,
    ReferenceInput,
    SelectInput,
    NumberInput,
    required
} from 'react-admin';

import Edit from '../common/views/Edit';
import CategoryInput from './inputs/CategoryInput';
import StatusInput from './inputs/StatusInput';
import PriorityInput from './inputs/PriorityInput';
import ParticipantsInput from './inputs/ParticipantsInput';

const TaskEdit = props => (
    <Edit {...props}>
        <SimpleForm redirect="show">
            <TextInput source="title" validate={required()} fullWidth />
            <TextInput source="description" multiline rows="4" fullWidth />
            <CategoryInput validate={required()} />
            <StatusInput />
            <PriorityInput />
            <NumberInput source="progress" min={0} max={100} step={5} />
            <ReferenceInput source="owner_id" reference="users">
                <SelectInput optionText="fullname" validate={required()} />
            </ReferenceInput>
            <ParticipantsInput />
            <DateInput source="due_date" />
        </SimpleForm>
    </Edit>
);

export default TaskEdit;
